import { Component } from '@theme/component';
import { onDocumentLoaded } from '@theme/utilities';
import { MegaMenuHoverEvent } from '@theme/events';

class HeaderMenu extends Component {
  requiredRefs = ['overflowMenu'];

  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const items = this.querySelectorAll('.menu-list__list-item');

    let enterTimeout;
    let leaveTimeout;
    let activeItem = null;

    items.forEach((item) => {
      const submenu = item.querySelector('.menu-list__submenu');

      // 👉 ENTER (DELAYED SWITCH)
      item.addEventListener('mouseenter', () => {
        clearTimeout(leaveTimeout);
        clearTimeout(enterTimeout);

        enterTimeout = setTimeout(() => {
          // remove previous
          if (activeItem && activeItem !== item) {
            activeItem.classList.remove('is-active');
          }

          // activate current
          item.classList.add('is-active');
          activeItem = item;

          this.dispatchEvent(new MegaMenuHoverEvent());
        }, 150); // 🔥 sweet spot
      });

      // 👉 LEAVE (SMART CLOSE)
      item.addEventListener('mouseleave', () => {
        clearTimeout(enterTimeout);

        leaveTimeout = setTimeout(() => {
          const hoveringItem = item.matches(':hover');
          const hoveringSubmenu = submenu && submenu.matches(':hover');

          if (!hoveringItem && !hoveringSubmenu) {
            item.classList.remove('is-active');

            if (activeItem === item) {
              activeItem = null;
            }
          }
        }, 220); // slightly higher = smoother diagonal
      });

      // 👉 SUBMENU HOVER FIX (CRITICAL)
      if (submenu) {
        submenu.addEventListener('mouseenter', () => {
          clearTimeout(leaveTimeout);
        });

        submenu.addEventListener('mouseleave', () => {
          leaveTimeout = setTimeout(() => {
            if (!item.matches(':hover')) {
              item.classList.remove('is-active');

              if (activeItem === item) {
                activeItem = null;
              }
            }
          }, 220);
        });
      }
    });

    onDocumentLoaded(this.#preloadImages);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }

  #preloadImages = () => {
    const images = this.querySelectorAll('img[loading="lazy"]');
    images?.forEach((image) => image.removeAttribute('loading'));
  };
}

if (!customElements.get('header-menu')) {
  customElements.define('header-menu', HeaderMenu);
}